<div class="mat-dialog-header">
  <div class="mat-dialog-title">
    {{title}}
    <span class="behavior-tracking-student-count">
      {{students.length}} {{students.length > 1 ? "Students Selected" : "Student Selected"}}
    </span>
  </div>
  <fa-icon (click)="dialogRef.close()" [icon]="['fas', 'close']"></fa-icon>
</div>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div mat-dialog-content>
  <ng-container *ngIf="!isLoading && behaviorCodeTypeOptions?.length">
    <mat-form-field class="full-width-input">
      <mat-label>Behavior Type</mat-label>
      <input type="text" matInput [formControl]="behaviorCodeTypeIdControl" [matAutocomplete]="auto" placeholder="Select an option">
      <mat-icon matSuffix class="icon" *ngIf="!behaviorCodeTypeIdControl.value">arrow_drop_down</mat-icon>
      <button
        matSuffix
        class="icon"
        *ngIf="behaviorCodeTypeIdControl.value"
        mat-icon-button
        aria-label="Clear"
        (click)="onClear('behaviorCodeTypeIdControl')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeTypeOptions')" showPanel="true">
        <mat-option *ngFor="let option of filteredBehaviorTypes | async" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="!isLoading && behaviorCodeOptions?.length">
    <mat-form-field class="full-width-input">
      <mat-label>Behavior Code</mat-label>
      <input type="text" matInput [formControl]="behaviorCodeIdControl" [matAutocomplete]="autoCode" placeholder="Select an option">
      <mat-icon matSuffix class="icon" *ngIf="!behaviorCodeIdControl.value">arrow_drop_down</mat-icon>
      <button
        matSuffix
        class="icon"
        *ngIf="behaviorCodeIdControl.value"
        mat-icon-button
        aria-label="Clear"
        (click)="onClear('behaviorCodeIdControl')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #autoCode="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeOptions')" showPanel="true">
        <mat-option *ngFor="let option of filteredBehaviorCodes | async" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="!isLoading && behaviorCodeReactionOptions?.length">
    <mat-form-field class="full-width-input">
      <mat-label>Reaction</mat-label>
      <input type="text" matInput [formControl]="behaviorCodeReactionIdControl" [matAutocomplete]="autoReaction" placeholder="Select an option">
      <mat-icon matSuffix class="icon" *ngIf="!behaviorCodeReactionIdControl.value">arrow_drop_down</mat-icon>
      <button
        matSuffix
        class="icon"
        *ngIf="behaviorCodeReactionIdControl.value"
        mat-icon-button
        aria-label="Clear"
        (click)="onClear('behaviorCodeReactionIdControl')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #autoReaction="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeReactionOptions')" showPanel="true">
        <mat-option *ngFor="let option of filteredReactions | async" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
  <ng-container
    *ngIf="!isLoading && behaviorCodeOptions?.length && hasPrivilege(PrivilegeEnum.CREATE_BEHAVIOR_NOTES)">
    <!-- Note field -->
    <mat-form-field class="text-area">
      <mat-label>Notes</mat-label>
      <textarea
        class="text-area"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="15"
        [formControl]="notesControl"
        matInput
        placeholder="Notes"></textarea>
    </mat-form-field>
  </ng-container>

  <div class="modal-action-row">
    <button
      type="button"
      mat-button
      class="modal-cancel-button"
      (click)="dialogRef.close();">
      Cancel
    </button>
    <button
      [disabled]="isLoading || isSubmitDisabled"
      type="submit"
      mat-button
      class="modal-submit-button"
      (click)="submit()">
      Track
    </button>
  </div>
</div>
